// @flow

import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { chatMessageType } from '../../types';
import { hpfetch, hpfetchWithoutContentType } from '../util';

export const getSingle = (
  chatId: number,
  id: number,
): Promise<wrappedApiResponseType<chatMessageType>> =>
  hpfetch(`chats/${chatId}/messages/${id}/`);

export const getMany = (
  chatId: number,
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<chatMessageType> =>
  hpfetch(`chats/${chatId}/messages/?limit=${limit}&offset=${offset}`);

export const create = (chatId: number, fields: any) =>
  hpfetch(`chats/${chatId}/messages/`, {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const createWithImages = (chatId: number, images: any) => {
  const endpoint = `chats/${chatId}/image_message/`;
  const form = new FormData();
  images.forEach(i => {
    form.append('images', i.blob);
  });
  // form.append('images', images[0].blob);

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
    body: form,
    // headers: { "Content-Type": "multipart/form-data" }
  });

  // hpfetch(`chats/${chatId}/messages/`, {
  //   method: 'POST',
  //   body: JSON.stringify(fields),
  // });
};

export const update = (chatId: number, id: number, fields: any) =>
  hpfetch(`chats/${chatId}/messages/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });
